// AssetsTab.tsx
import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { useToast } from "@shared/ui/use-toast";
import { Box, Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AssetsTable } from "./assetsList";

export const AssetsLanding = () => {
  const [showAssetSearchDialog, setShowAssetSearchDialog] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  useEffect(() => {
    logEvent("assets_tab_viewed");
  }, []);

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
            <Box className="h-5 w-5 text-indigo-600" />
          </div>
          <div>
            <PageHeader
              title="Assets Management"
              subtitle="Monitor and manage all assets within facility systems and networks"
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => {
              navigate("/ax/asset-registry/assets/create/add");
            }}
            className="bg-blue-600 hover:bg-blue-700"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Asset
          </Button>
        </div>
      </div>

      <AssetsTable />
    </div>
  );
};
